// Per-slide autoplay timing for the hero slider.
//
// Horizon's slideshow engine (assets/slideshow.js) auto-advances on ONE global interval (the
// `autoplay` attribute, in seconds) for every slide. This companion lets each slide override its
// own dwell time — e.g. a video slide can stay longer than a still image — WITHOUT editing the
// base engine.
//
// How: on every slide change the engine dispatches a bubbling `slideshow:select` event whose
// `detail.slide` is the active <slideshow-slide>. We read that slide's `data-hero-duration`
// (written by hero-slide-frame.liquid). If it's set, we swap the component's `autoplay` attribute
// to that value and call the engine's own `resume()` (which re-reads the attribute and restarts
// the interval). If it's not set, we restore the section's default speed. Pause-on-hover,
// visibility, drag, aria-live, etc. all keep working — they're untouched.

(() => {
  const bind = (slideshow) => {
    if (slideshow.dataset.heroTimingBound) return;
    slideshow.dataset.heroTimingBound = '1';

    // The section's default autoplay speed (seconds), captured before we start swapping it.
    const defaultSpeed = slideshow.getAttribute('autoplay');
    // Nothing to do if the slider isn't auto-rotating.
    if (!defaultSpeed) return;

    // Runs on EVERY select — auto-advance and user-initiated (drag/scroll/dot/arrow) alike. That's
    // intentional: after a manual swipe the next dwell should reflect the slide the user landed on.
    slideshow.addEventListener('slideshow:select', (event) => {
      const slide = event.detail && event.detail.slide;
      if (!slide) return;

      const frame = slide.querySelector('[data-hero-duration]');
      const perSlide = frame ? parseInt(frame.getAttribute('data-hero-duration'), 10) : 0;
      const next = perSlide > 0 ? String(perSlide) : defaultSpeed;

      if (slideshow.getAttribute('autoplay') !== next) {
        slideshow.setAttribute('autoplay', next);
      }

      // Re-arm the interval with the (possibly new) duration. resume() = pause() + play(), and
      // play() re-reads the `autoplay` attribute. Skip when the user/engine has paused it.
      if (typeof slideshow.resume === 'function' && !slideshow.paused) {
        slideshow.resume();
      }
    });
  };

  const init = () => {
    document.querySelectorAll('slideshow-component.hero-slider').forEach(bind);
  };

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
